import { Component, OnInit, Input } from '@angular/core';
import { LmsUserService } from 'lms-api';
import { Course } from 'lms-api';
import { CourseFilterService } from '../_services/course-filter.service';

@Component({
  selector: 'app-course-listview-grid',
  templateUrl: './course-listview-grid.component.html',
  styleUrls: ['./course-listview-grid.component.scss']
})
export class CourseListviewGridComponent implements OnInit {
  @Input() courses: Course[];

  constructor(private lmsUserService: LmsUserService, public courseFilterService: CourseFilterService) { }

  ngOnInit() {
  }
  
  ngAfterViewInit() {
    let titleElements = document.querySelectorAll('app-course-view-grid h4.title a');
    let maxTitleHeightByRow = {};
    let elementsByRow = {};
    titleElements.forEach((node) => {
      let el = <HTMLElement>node;
      //Round the top down to the nearest 10 to avoid 1 or 2 px differences
      let rowTop = Math.floor(el.offsetTop / 10) * 10;
      if(elementsByRow[rowTop] == null) { 
        maxTitleHeightByRow[rowTop] = 0;
        elementsByRow[rowTop] = []; 
      }
      elementsByRow[rowTop].push(el);
      maxTitleHeightByRow[rowTop] = el.offsetHeight > maxTitleHeightByRow[rowTop] ? el.offsetHeight : maxTitleHeightByRow[rowTop];
    });
    for(let rowTop in elementsByRow) {
      elementsByRow[rowTop].forEach((el) => {
        el.style.height = maxTitleHeightByRow[rowTop] + 'px';
      });
    }
  }

  courseId(index: number, course: Course) {
    return course.netforum_course_id;
  }

}
